export default __webpack_public_path__ + "static/media/ar.e4728893.svg";